import { render } from "./PrintOrderModal.vue?vue&type=template&id=3f7b8b2c"
import script from "./PrintOrderModal.vue?vue&type=script&lang=js"
export * from "./PrintOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__